"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlexStyles = void 0;
var _display = require("../styles/display");
var _flex = require("../styles/flex");
var _linaria = require("../utils/linaria");
const _excluded = ["display"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const getFlexStyles = _ref => {
  let _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'flex' : _ref$display,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return (0, _linaria.cx)(_display.display[display], props.alignContent && _flex.alignContent[props.alignContent], props.alignItems && _flex.alignItems[props.alignItems], props.alignSelf && _flex.alignSelf[props.alignSelf], props.flexDirection && _flex.flexDirection[props.flexDirection], props.flexWrap && _flex.flexWrap[props.flexWrap], props.justifyContent && _flex.justifyContent[props.justifyContent]);
};
exports.getFlexStyles = getFlexStyles;